import * as React from 'react';
import { Box } from '@mui/material';
import { Document } from '@maiia/model/generated/model/api-patient/api-patient';

import useDocumentThumbnail from '@/src/hooks/useDocumentThumbnail';
import Loader from '@/components/atoms/Loader/Loader';

type Props = {
  document: Document;
  onClick?: (event: React.MouseEvent) => void;
};

const DocumentThumbnail = ({ document, onClick }: Props) => {
  const documentThumbnailUrl = useDocumentThumbnail(document);

  if (!documentThumbnailUrl) {
    return (
      <Loader
        size={20}
        color="secondary"
        sx={{
          position: 'absolute',
          // Center loader (50% - size/2), transofrm is used for spinning
          top: 'calc(50% - 10px)',
          left: 'calc(50% - 10px)',
        }}
      />
    );
  }

  return (
    <Box
      className="document__image"
      sx={{
        backgroundImage: `url("${documentThumbnailUrl}")`,
        cursor: 'pointer',
      }}
      onClick={onClick}
    />
  );
};

export default DocumentThumbnail;
